import { useFiltersStore } from "@/store/pinia/filters";
import { getDefaultFiltersForKey } from "@components/constants/filterDefaultsRegistry";

export function useFilters() {
  const filtersStore = useFiltersStore();

  const setFilters = ({ key, filters }) => {
    filtersStore.setFilters({ key, filters });
  };

  const getFilters = (key) => {
    filtersStore.loadFilters(key);
    return filtersStore.filters;
  };

  /**
   * ER-11195: Restore a table's documented default filters.
   *
   * Reads the default from the central registry (filterDefaultsRegistry),
   * persists it through the filters store (Access-scoped storage), and returns
   * the defaults so the caller can re-apply them to view state. This backs the
   * "reset to defaults" user action — distinct from resetFilters() which only
   * clears in-memory state on logout / Access switch.
   *
   * @param {string} key - Persisted filter storage key
   * @returns {string[]} The registered default filter values ([] when unregistered)
   */
  const resetToDefaults = (key) => {
    const defaults = getDefaultFiltersForKey(key) || [];
    filtersStore.setFilters({ key, filters: defaults });
    return defaults;
  };

  return {
    setFilters,
    getFilters,
    resetToDefaults,
  };
}
